export const sessionHelper = {
  methods: {
    getSessionVarString: function (userId) {
      var sessionVariables = {
        UserId: userId
      }
      return btoa(JSON.stringify(sessionVariables))
    }
  }
}
